import { lisk as viemLisk } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const lisk = {
  displayName: 'Lisk',
  runtime: 'evm',
  viemChain: viemLisk,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'lisk' },
    qnStreams: {
      networkKey: 'lisk-mainnet',
    },
  }),
} as const satisfies AllChainConfig<'evm', false>;
